<main id="content">
  <div>
    <ds-home-news-uner>
      <!-- INICIO -->
    </ds-home-news-uner>
    <!-- Nuevas Comunidades -->
    <!-- <ds-top-level-community-list-uner></ds-top-level-community-list-uner> -->
    <section class="communities-section">
      <div class="row row-equal no-gutters">
        <div class="col-md-3 col-sm-6 col-xs-12">
          <a href="https://ritest.uner.edu.ar/handle/123456789/1">
            <div class="services text-center">
              <div class="icon">
                <span class="icono-uner icono-libros"></span>
              </div>
              <div class="services-body">
                <h6 class="titulo-azul-oscuro">Buscar en el repositorio</h6>
                <p class="titulo-azul-oscuro">
                  Colección que contiene artículos científicos y más producción científico-técnica,
                  tanto de investigadores como de becarios de la Universidad Nacional de Entre Ríos y de otras
                  instituciones.
                </p>
              </div>
            </div>
          </a>
        </div>
        <div class="col-md-3 col-sm-6 col-xs-12">
          <a href="https://ritest.uner.edu.ar/handle/123456789/2">
            <div class="services text-center">
              <div class="icon">
                <span class="icono-uner icono-articulos"></span>
              </div>
              <div class="services-body">
                <h6 class="titulo-azul-oscuro">Articulos y Publicaciones</h6>
                <p class="titulo-azul-oscuro">
                  Colección que contiene artículos científicos y más producción científico-técnica,
                  tanto de investigadores como de becarios de la Universidad Nacional de Entre Ríos y de otras
                  instituciones.
                </p>
              </div>
            </div>
          </a>
        </div>
        <div class="col-md-3 col-sm-6 col-xs-12">
          <a href="https://ritest.uner.edu.ar/handle/123456789/3">
            <div class="services text-center">
              <div class="icon">
                <span class="icono-uner icono-tesis"></span>
              </div>
              <div class="services-body">
                <h6 class="titulo-azul-oscuro">Tesis y trabajos finales</h6>
                <p class="titulo-azul-oscuro">
                  Colección que contiene artículos científicos y más producción científico-técnica,
                  tanto de investigadores como de becarios de la Universidad Nacional de Entre Ríos y de otras
                  instituciones.
                </p>
              </div>
            </div>
          </a>
        </div>
        <div class="col-md-3 col-sm-6 col-xs-12">
          <a href="https://ritest.uner.edu.ar/handle/123456789/4">
            <div class="services text-center">
              <div class="icon">
                <span class="icono-uner icono-congresos"></span>
              </div>
              <div class="services-body">
                <h6 class="titulo-azul-oscuro">Congresos y jornadas</h6>
                <p class="titulo-azul-oscuro">
                  Colección que contiene artículos científicos y más producción científico-técnica,
                  tanto de investigadores como de becarios de la Universidad Nacional de Entre Ríos y de otras
                  instituciones.
                </p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
    <!-- Areas de la UNER -->

    <section class="area-section">
      <div class="bgimg-rectorado-uner">
          <div class="caption text-center container">
            <h2>
              Repositorio Institucional de la UNER
            </h2>
        </div>
      </div>
    </section>

    <section class="area-section">
      <div class="container">
        <div class="row">

          <div class="bgimg col-md-6 img-bg-2">
            <div class="caption text-left container">
              <h2>
                Subí tu investigación o Desarrollo al RI-UNER
              </h2>
              <button class="btn-mas-info">MÁS INFORMACION</button>
          </div>
          </div>

          <div class="col-md-6 area-text">
            <div class="row">
              <div class="col-md-12">
                <a href="/handle/20.500.12049/54">
                  <div class="area-body">
                    <div class="icon icono-riuner-08"></div> <!-- Icono 08 aplicado aquí -->
                    <div class="text">
                      <h3 class="fw-light">Políticas de Acceso Abierto</h3>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-md-12">
                <a href="/handle/20.500.12049/237">
                  <div class="area-body">
                    <div class="icon icono-riuner-09"></div> <!-- Icono 09 aplicado aquí -->
                    <div class="text">
                      <h3 class="fw-light">Normativa</h3>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-md-12">
                <a href="/handle/20.500.12049/237">
                  <div class="area-body">
                    <div class="icon icono-riuner-10"></div> <!-- Icono 10 aplicado aquí -->
                    <div class="text">
                      <h3 class="fw-light">Preguntas frecuentes</h3>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
    <section class="recent-submissions">
      <div class="container">
        <ds-recent-item-list-uner *ngIf="recentSubmissionspageSize>0"></ds-recent-item-list-uner>
      </div>
    </section>
  </div>
</main>